import { Dispatch } from "redux";
import { UIState, SET_activeTab, SET_hidden, SET_slideClass } from "../reducers/uiReducer";
import { isEnvBrowser } from "./misc";
import { socketRequest } from "./socketRequest";

/**
 * Starts the hide event by sliding the UI down, hiding it, and then resetting the slide class.
 *
 * @param dispatch - The Redux dispatch function.
 */
export const startHideEvent = async (dispatch: Dispatch) => {
    // Slide the UI down
    dispatch(SET_slideClass("slideDownPointFive"));
    
    // Wait for 250ms
    setTimeout(async () => {
        // Hide the UI
        if (isEnvBrowser()) {
            dispatch(SET_hidden(true));
        } else {
            await socketRequest("CloseUI");
        }

        // Reset the slide class
        dispatch(SET_slideClass("slideUpPointFive"));
    }, 250);
};